import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CurrencyEthereum, CurrencyMatic, ArbitrumLogo, BaseLogo, OptimismLogo, Beaker02 as TestnetLogo, ZoraLogo, EthereumLogo, } from "@hl/base-components/lib/assets/icons.generated";
const getNativeCurrencyIcon = (platform, size) => {
    const chain = platform.toLowerCase();
    if (chain.includes("sepolia") ||
        chain.includes("goerli") ||
        chain.includes("mumbai"))
        return _jsx(TestnetLogo, { height: size, width: size });
    if (chain.includes("polygon"))
        return _jsx(CurrencyMatic, { height: size, width: size });
    if (chain.includes("ethereum"))
        return _jsx(EthereumLogo, { height: size, width: size });
    if (chain.includes("arbitrum"))
        return _jsx(ArbitrumLogo, { height: size, width: size });
    if (chain.includes("base"))
        return _jsx(BaseLogo, { height: size, width: size });
    if (chain.includes("optimism"))
        return _jsx(OptimismLogo, { height: size, width: size });
    if (chain.includes("zora"))
        return _jsx(ZoraLogo, { height: size, width: size });
    return _jsx(CurrencyEthereum, { height: size, width: size });
};
const getNativeCurrencyName = (platform) => {
    const chain = platform.toLowerCase();
    switch (chain) {
        case "polygon":
            return "Matic";
        case "mumbai":
            return "Matic";
        case "ethereum":
            return "Eth";
        case "goerli":
            return "Goerli Eth";
        case "sepolia":
            return "Sepolia Eth";
        case "arbitrum":
            return "Eth";
        case "arbitrum-goerli":
            return "Goerli Eth";
        case "optimism":
            return "Eth";
        case "optimism-goerli":
            return "Goerli Eth";
        case "base":
            return "Base";
        case "base-goerli":
            return "Goerli Eth";
        case "base-sepolia":
            return "Sepolia Eth";
        case "zora":
            return "Eth";
        case "zora-goerli":
            return "GöETH";
        default:
            return "Unknown";
    }
};
const getCurrencySymbol = (chainId, camelcase) => {
    switch (chainId.toString()) {
        case "1":
            return camelcase ? "Eth" : "ETH";
        case "5":
            return camelcase ? "GoerliEth" : "GoerliETH";
        case "11155111":
            return camelcase ? "SepoliaEth" : "SepoliaETH";
        case "137":
        case "80001":
            return camelcase ? "Matic" : "MATIC";
        case "42161":
            return camelcase ? "Eth" : "ETH";
        case "421613":
            return camelcase ? "GoerliEth" : "AGOR";
        case "10":
            return camelcase ? "Eth" : "ETH";
        case "420":
            return camelcase ? "GoerliEth" : "GoerliETH";
        case "8453":
            return camelcase ? "Eth" : "ETH";
        case "84531":
            return camelcase ? "GoerliEth" : "GoerliETH";
        case "84532":
            return camelcase ? "SepoliaEth" : "SepoliaETH";
        case "7777777":
            return camelcase ? "Eth" : "ETH";
        case "999":
            return camelcase ? "GöEth" : "GöETH";
        default:
            return camelcase ? "Unknown" : "UNKNOWN";
    }
};
export { getCurrencySymbol, getNativeCurrencyName, getNativeCurrencyIcon };
